import { useMemo } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../utils/config';
import { useAuth } from '../../context/AuthContext';

const unwrap = (res) =>
  res && res.data && Object.prototype.hasOwnProperty.call(res.data, 'data') ? res.data.data : res.data;

/**
 * Authenticated API client for an NF-style module, parameterised by base path.
 *   const api = useModuleApi('/construction');
 *   api.list('insaat_talep', {tip: 0})
 *   api.get('/insaat-takip')
 */
export function useModuleApi(base) {
  const { getAuthHeaders, token } = useAuth();
  return useMemo(() => {
    const root = `${API_BASE_URL}${base}`;
    const cfg = () => ({ headers: getAuthHeaders() });
    return {
      list: (resource, params = {}) =>
        axios.get(`${root}/records/${resource}`, { ...cfg(), params }).then(unwrap),
      create: (resource, payload) =>
        axios.post(`${root}/records/${resource}`, payload, cfg()).then((r) => r.data),
      update: (resource, id, payload) =>
        axios.put(`${root}/records/${resource}/${id}`, payload, cfg()).then((r) => r.data),
      remove: (resource, id) =>
        axios.delete(`${root}/records/${resource}/${id}`, cfg()).then((r) => r.data),
      get: (path, params = {}) => axios.get(`${root}${path}`, { ...cfg(), params }).then(unwrap),
      post: (path, body = {}) => axios.post(`${root}${path}`, body, cfg()).then((r) => r.data),
    };
  }, [token, base]);
}

export const DOVIZ = ['TRY', 'USD', 'EUR', 'GBP'].map((d) => ({ value: d, label: d }));
